<div class="container">
  <div class="item item-1">
    <div class="item item-1"></div>
    <div class="item item-2"></div>
    <div class=""></div>
    <div class="item item-4"></div>
  </div>
  <div class="item item-2">
    <div class="item item-1"></div>
    <div class="item item-2"></div>
    <div class="item item-3"></div>
    <div class=""></div>
  </div>
  <div class="item item-3">
    <div class=""></div>
    <div class="item item-2"></div>
    <div class="item item-3"></div>
    <div class="item item-4"></div>
  </div>
  <div class="item item-4">
    <div class="item item-1"></div>
    <div class=""></div>
    <div class="item item-3"></div>
    <div class="item item-4"></div>
  </div>
</div>
